import { useQuery, type QueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'

export type SidebarReviewCounts = {
  allegro_grafikomat: number
  allegro_parametry: number
  allegro_tytuly_v2: number
  allegro_opisomat: number
  allegro_kompleksowe: number
  allegro_wystawianie_od_zera: number
}

export const SIDEBAR_REVIEW_COUNTS_KEY = ['allegro-flow-review-counts'] as const

const EMPTY: SidebarReviewCounts = {
  allegro_grafikomat: 0,
  allegro_parametry: 0,
  allegro_tytuly_v2: 0,
  allegro_opisomat: 0,
  allegro_kompleksowe: 0,
  allegro_wystawianie_od_zera: 0,
}

/** Call after delete / cancel / enter or leave review so sidebar badges stay in sync. */
export function invalidateSidebarReviewCounts(qc: QueryClient) {
  void qc.invalidateQueries({ queryKey: SIDEBAR_REVIEW_COUNTS_KEY })
}

export function useSidebarReviewCounts(enabled = true) {
  return useQuery({
    queryKey: SIDEBAR_REVIEW_COUNTS_KEY,
    queryFn: async () => {
      const { data } = await api.get<SidebarReviewCounts>('/allegro/flow-meta/review-counts')
      return data
    },
    enabled,
    staleTime: 15_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  })
}

export function reviewCountForModule(
  counts: SidebarReviewCounts | undefined,
  moduleId: string,
): number {
  if (!counts) return 0
  if (moduleId in counts) {
    return counts[moduleId as keyof SidebarReviewCounts] || 0
  }
  return 0
}

export { EMPTY as EMPTY_REVIEW_COUNTS }
